import React from "react";
import { Box, Text, Flex } from "@chakra-ui/react";

const GradientLine = () => {
  return (
    <Box
      position="relative"
      width="30px"
      height="6px"
      display="flex"
      alignItems="center"
    >
      <Box
        width="12px"
        height="12px"
        borderRadius="50%"
        backgroundColor="#BFBFBF"
        position="absolute"
        left="0"
        top="50%"
        transform="translateY(-50%)"
      />

      <Box
        width="100%"
        height="2px"
        marginLeft="10px"
        background="linear-gradient(to right, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0) 100%)"
      />
    </Box>
  );
};

const MessageBox = ({icon, title, description, rotation, direction}) => {
  return (
    <Box
      position="relative"
      display="inline-flex"
      alignItems="center"
      padding="6px 10px"
      fontSize="16px"
      color="white"
      borderRadius="12px"
      background={`linear-gradient(${rotation}, rgba(255, 255, 255, 0.0) 0%, rgba(255, 255, 255, 0.05) 100%)`}
      _before={{
        content: '""',
        position: "absolute",
        inset: "0",
        borderRadius: "12px",
        padding: "1px",
        background:
          `linear-gradient(to ${direction}, rgba(255, 255, 255, 0.25) 25%, rgba(255, 255, 255, 0.00) 100%)`,
        WebkitMask:
          "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
        WebkitMaskComposite: "xor",
        maskComposite: "exclude",
        pointerEvents: "none",
      }}
      width={{sm: "auto", md: "auto", lg: "600px", xl: "600px"}}
      maxW={"100%"}
      height={{base: "180px", md: "auto"}}
    >
      <Flex
        padding={"20px 15px"}
        direction={"row"}
        gap={"19px"}
        width={"100%"}
        alignItems={"center"}
      >
        <Box padding={"14px"} background={"rgba(255, 255, 255, 0.10)"} borderRadius={"7px"} width={"51px"} height={"51px"}>
          {icon}
        </Box>
        <Flex direction={"column"}>
            <Flex direction={"row"} gap={"10px"} alignItems={"center"}>
              <GradientLine />
              <Text fontSize={"24px"} >
                {title.split(" ")[0]}
                {" "}
                <Text as={"span"} fontWeight={"600"}>{title.split(" ")[1]}</Text>
              </Text>
              </Flex>
            <Text fontSize={"16px"} color={"#B6B6B6"}>
            {description}
            </Text>
          </Flex>

      </Flex>
    </Box>
  );
};

export default MessageBox;
